<template>
	<div>
		<div class="btn" v-if="show" @click="goback">
			<img src="../../assets/images/goback-btn.png" class="img"></img>
		</div>
		<div class="content" v-html="agreements[active].content"></div>
	</div>

</template>

<script>
	import liveplayAgreement from '@/assets/scripts/agreements/liveplay-agreement.js';
	import privacyAgreement from '@/assets/scripts/agreements/privacy-agreement.js';
	import userAgreement from '@/assets/scripts/agreements/user-agreement.js';
	import disclaimer from '@/assets/scripts/agreements/disclaimer.js';
	import doctorDetails from '@/assets/scripts/agreements/doctor.js';
	export default {
		data() {
			return {
				agreements: {
					user: {
						title: '用户协议',
						content: userAgreement
					},
					privacy: {
						title: '隐私协议',
						content: privacyAgreement
					},
					disclaimer: {
						title: '免责声明',
						content: disclaimer
					},
					liveplay: {
						title: '直播协议',
						content: liveplayAgreement
					},
					doctorDetails: {
						title: '亮健康医生端隐私协议',
						content: doctorDetails
					}
				},
				active: 'user',
				show: false

			};
		},
		created() {
			const type = this.$route.params.type;
			if (type && this.agreements[type]) this.active = type;

			document.title = this.agreements[this.active].title;
		},
		mounted() {
			if (window.location.href.indexOf("pageFrom=webview") > -1) {
				document.getElementsByClassName("content")[0].classList.add("webview");
			}
			if (window.location.href.indexOf("pageFrom=yinliu") > -1) {
				this.show = true
			}
		},
		methods: {
			goback() {
				history.back()
			}
		}
	};
</script>

<style scoped>
	body {
		margin: 0;
		padding: 0;
	}

	.content {
		width: 95%;
		color: #333333;
		font-size: 13px;
		padding: 2.5%;
		padding-top: 0;
		line-height: 1.6;
		white-space: pre-line;
	}

	.content.webview {

		word-wrap: break-word;
		white-space: normal;
		word-break: break-all;
		text-align: justify;
	}

	.btn {
		width: 20px;
		height: 20px;

	}

	.img {
		width: 100%;
		height: 100%;
	}

	table {}
</style>
